<app-tabla
  [totalCount]="totalCount"
  [datos]="recorridos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay recorridos', subtitle: 'Creá un recorrido para asignarlo a los colectivos de una línea.' }"
></app-tabla>
